exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".error[data-v-bf26eaae]{margin:0 auto;max-width:640px;min-height:100%;background:#fff}p[data-v-bf26eaae]{margin:0 auto;padding-top:25vh;width:235px;font-size:20px;font-weight:700}", "", {"version":3,"sources":["/Users/zhouzhuang/software/IdeaProjects/cartx/web/shop/src/views/Error.vue"],"names":[],"mappings":"AACA,wBACI,cAAe,AACf,gBAAiB,AACjB,gBAAiB,AACjB,eAAiB,CACpB,AACD,mBACI,cAAe,AACf,iBAAkB,AAClB,YAAa,AACb,eAAgB,AAChB,eAAkB,CACrB","file":"Error.vue","sourcesContent":["\n.error[data-v-bf26eaae] {\n    margin: 0 auto;\n    max-width: 640px;\n    min-height: 100%;\n    background: #fff;\n}\np[data-v-bf26eaae] {\n    margin: 0 auto;\n    padding-top: 25vh;\n    width: 235px;\n    font-size: 20px;\n    font-weight: bold;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bf26eaae","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Error.vue
// module id = ii/j
// module chunks = 9